export const REQUEST_ORDER_ASURINT = gql`
  mutation REQUEST_ORDER_ASURINT($packageId: String!, $applicantId: String!) {
    orderResponse: generateOrder(packageId: $packageId, applicantId: $applicantId) {
      orderId
      orderUrl
    }
  }
`